export function getPurchaseErrorMessage(error, fallback) {
  const message =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.data?.detail ||
    error?.data?.message ||
    error?.message;

  return Array.isArray(message) ? message.join(" · ") : message || fallback;
}
